/**
 * Wall palette. The stage is flush dark charcoal with an amber accent, scoped
 * by a nested antd `ConfigProvider` (dark algorithm, zero radius) inside
 * `ArtworkWall` so overlaid antd controls pick the right tokens. Chrome
 * outside the wall keeps the app's rose theme. No `.ant-*` overrides anywhere.
 */
export const WALL_STAGE_BG = "#1c1c1e"
export const WALL_TILE_BG = "#2a2a2d"
export const WALL_CHROME_BG = "#141416"
export const WALL_ACCENT = "#f2b134"
export const WALL_TEXT = "rgba(255, 255, 255, 0.85)"
export const WALL_TEXT_MUTED = "rgba(255, 255, 255, 0.45)"
